var map = {
	"./attention_apps.md": [
		4147,
		147
	],
	"./attention_research.md": [
		1246,
		246
	],
	"./doing_nothing_3_hours.md": [
		2421,
		421
	],
	"./doing_nothing_6_people.md": [
		6578,
		578
	],
	"./godswork.md": [
		9854,
		854
	],
	"./london-to-brighton.md": [
		5090,
		90
	],
	"./morocco_no_phone.md": [
		223,
		223
	],
	"./phone_diet_7_days.md": [
		819,
		819
	],
	"./phony_digital_fasting.md": [
		5768,
		768
	],
	"./phony_travel.md": [
		4361,
		361
	],
	"./ukraine_aid.md": [
		3354,
		354
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 594;
module.exports = webpackAsyncContext;